import React, {Fragment} from "react";
import PropTypes from "prop-types";
import { LineChart as RechartLineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from "recharts";
import { ChartLoader } from "../DataChart";
import {get} from "../../../../utils/dotutils";

export default class LineChart extends React.Component {

    static propTypes = {
        // the fieldname used as the base of grouping (the "line label")
        base: PropTypes.string,
        // an array containing the dataKey for the lines' value
        visibleData: PropTypes.array,
        // the field used for ordering the data (the "X axis")
        orderField: PropTypes.string,
        // an object containing a realHeight (number) and realWidth (number)
        activeDimensions: PropTypes.object,
    }

    render() {

        const chartWidth = this.props.activeDimensions?.realWidth || 500

        if (this.props.value.length != 0 && !this.props.orderField) {
            if (!this.props.orderFields || (Array.isArray(this.props.orderFields) && this.props.orderFields.length == 0)) {
                return <div className="data-chart-error">
                    Hiba a widget beállításaiban: az X tengely lehetséges értéke ismeretlen.
                </div>;
            }
            return <div className="data-chart-error">
                Válassz ki egy mezőt az X értéknek!
            </div>;
        } else if (this.props.visibleData.length > 1) {
            return <div className="data-chart-error">
                Kérlek, egy megjelenítendő adatot válassz ki!
            </div>;
        }

        const dataKey = this.props.visibleData[0];

        let data = {};
        let lines = {};
        
        this.props.value.forEach(item => {
            const key = item[this.props.orderField];
            const baseLabel = get(item, this.props.base);
            lines[baseLabel] = 0;
            data[key] = {
                ...data[key],
                [baseLabel]: item[dataKey],
            }
        });
        const transformedData = Object.keys(data).map(orderField => {
            return {
                [this.props.orderField]: orderField,
                ...lines,
                ...data[orderField]
            };
        });

        return this.props.value.length == 0 ? <ChartLoader /> :
            <RechartLineChart 
                width={chartWidth}
                height={this.props.activeDimensions?.realHeight ? this.props.activeDimensions.realHeight - 45 : 260}
                data={transformedData}>
                <CartesianGrid strokeDasharray="1 2" />
                <XAxis
                    dataKey={this.props.orderField}
                    // defines how many labels are shown: 0 = 'all of them'
                    interval={this.props.value.length < 10 ? 0 : "preserveEnd"}
                    angle={8}
                    tickMargin={10}
                    // tick={{stroke: 'red', strokeWidth: 2}}
                />
                <YAxis width={70} type="number" />
                <Tooltip 
                    formatter={(value, name, index) => [
                        this.props.columnSettings[dataKey]?.renderer(value) || value,
                        this.props.possibleVisibleColumns.find(col => col.value == name)?.label || name
                    ]}
                />
                <Legend />
                {Object.keys(lines).map((baseLabel, index) => <Line
                    key={"line-" + index}
                    type="monotone"
                    dataKey={baseLabel}
                    stroke={this.props.colors[index] || "#000"}
                    dot={false}
                />)}
            </RechartLineChart>;
    }
}